import styles from './modal-paragraph.module.scss';

export function ModalParagraph({ children }: { children: React.ReactNode }) {
  return <p className={styles.root}>{children}</p>;
}
